/* eslint-disable max-len */
export default [
  {
    title: 'Pro Xtra',
    description: 'Join Home Depot\'s Pro Xtra program for exclusive contractor benefits, discounts, and tools to save time and grow your business.',
    ctaUrl: '/c/pro-xtra',
    imageUrl: 'https://dam.thdstatic.com/content/production/tdLHZzHK3sB-DmCLor0X5Q/Eph7LBy-t-bHT_0fieINYA/Original%20file/Pro%20Xtra%20Tiers.jpg?im=Resize=(400)'
  },
  {
    title: 'HD Pass',
    description: 'Experience faster checkouts with Home Depot\'s HD Pass, unlock special pricing and perks for pros with seamless savings on every purchase.',
    ctaUrl: '/c/hd-pass',
    imageUrl: 'https://dam.thdstatic.com/content/production/OwHY4VUu6LNmqRFpEyzxSA/sfYm3pE9-l7SQwT2SrbFWQ/Original%20file/WhatIsHDpass_040325.jpg?im=Resize=(400)'
  },
  {
    title: 'Preferred Pricing Pass',
    description: 'Get Home Depot\'s Preferred Pricing Pass for exclusive online discounts tailored for Pro Xtra members and contractors.',
    ctaUrl: '/c/preferred-pricing-pass',
    imageUrl: 'https://dam.thdstatic.com/content/production/9jduFVoL7sE2PxG3IXggvw/cUIKSiO7R_L33DkAlcJNng/Original%20file/Hero_DT_040325.jpg?im=Resize=(400)'
  },
  {
    title: 'Construction Takeoff Services',
    description: 'Plan your projects with Home Depot\'s Construction Takeoff Services and get accurate material estimates and competitive quotes for pros, fast and easy.',
    ctaUrl: '/c/construction-takeoff-services',
    imageUrl: 'https://dam.thdstatic.com/content/production/R3cfsFFdHjP7qP1plBTHlg/86JgTXBEVEPo_o5tCb3E7A/PPS%20Pro%20Desk%204:3/PX1021-2852_PPS%20Pro%20Desk%2043.jpg?im=Resize=(400)'
  }
];